import React, { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Notice,
  Panel,
  PanelContent,
  PanelHeader
} from '@deque/cauldron-react';
import styles from './CustomIntegrationExtensionNotInstalled.css';
import Link from '../../common/components/Link';
import { PROD_EXTENSION_URL } from '../../common/constants';

const CustomIntegrationExtensionNotInstalled = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrap}>
      <Notice title={t('axe DevTools Extension Not Detected')} type="danger" />
      <Panel>
        <PanelHeader>
          <h2>{t('Enable the Extension')}</h2>
        </PanelHeader>
        <PanelContent>
          <p>
            {t(
              "If you've already installed axe DevTools, you may need to enable it:"
            )}
          </p>
          <ol>
            <li>
              {t("Access your browser's extensions menu through settings")}
            </li>
            <li>{t('Locate axe DevTools in your extensions list')}</li>
            <li>{t('Enable the extension using the toggle or checkbox')}</li>
            <li>{t('Return to this page and refresh to continue')}</li>
          </ol>
        </PanelContent>
      </Panel>
      <Panel>
        <PanelHeader>
          <h2>{t('Install axe DevTools')}</h2>
        </PanelHeader>
        <PanelContent>
          <p>
            {t(
              "To begin accessibility testing, you'll need to install the axe DevTools extension."
            )}
          </p>
          <p>
            <Link openInNewTab url={PROD_EXTENSION_URL}>
              {t('Install the axe DevTools Extension (opens in a new tab)')}
            </Link>
          </p>
          <p>
            {t(
              'After installation is complete, return to this page and refresh to begin your accessibility evaluation.'
            )}
          </p>
        </PanelContent>
      </Panel>
    </div>
  );
};

export default CustomIntegrationExtensionNotInstalled;
